import { createSelector } from 'reselect';

import { type FEATURE_FLAGS_REDUCER_KEY, featureFlagsSelectors } from 'app-components/flux/feature-flags';
import { getPreferenceValue } from 'app-components/flux/preferences-v2/preferencesV2Selectors';
import type { PREFERENCES_V2_REDUCER_KEY } from 'app-components/flux/preferences-v2/preferencesV2Types';
import type RootState from 'app-components/utils/redux-store/rootState';

type State = Pick<RootState, typeof FEATURE_FLAGS_REDUCER_KEY | typeof PREFERENCES_V2_REDUCER_KEY>;

export const selectPrivacyModeSettings = createSelector(
  [
    (state: State) => featureFlagsSelectors.getFeatureFlag(state, 'privacyMode'),
    (state: State) => getPreferenceValue(state, 'sPrivacyMode', false),
  ],
  (privacyModeFeatureFlag, privacyModePreference) => {
    return {
      privacyModeFeatureFlag,
      privacyModePreference,
    };
  },
);

const selectPrivacyModeEnabled = createSelector(
  [selectPrivacyModeSettings],
  // The flag is undefined until feature flags load, which reads as off.
  ({ privacyModeFeatureFlag, privacyModePreference }): boolean =>
    Boolean(privacyModePreference && privacyModeFeatureFlag),
);

export default selectPrivacyModeEnabled;
